import { render, staticRenderFns } from "./EmpfehlungComponent.vue?vue&type=template&id=9a62552a&scoped=true"
import script from "./EmpfehlungComponent.vue?vue&type=script&lang=js"
export * from "./EmpfehlungComponent.vue?vue&type=script&lang=js"
import style0 from "./EmpfehlungComponent.vue?vue&type=style&index=0&id=9a62552a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a62552a",
  null
  
)

export default component.exports